import PrimaryButton from "../../../Components/Buttons/primary-button";

import { modalVariants } from "../../../Utils/constants";

import { ReferAFriendModalImage } from "../../../Assets/Images";

export default function renderReferAFriend(modalContext, referAFriend) {
  const { updateModalComponent, setModalVariant, onModalClose } = modalContext;

  const handleInviteClick = () => {
    if (!!referAFriend?.invite_button_link) {
      // Open the URL in a new tab
      window.open(referAFriend.invite_button_link, "_blank", "noopener,noreferrer");
    }
  };

  updateModalComponent(() => (
    <>
      <div className="modal-dialog-content">
        <ReferAFriendModalImage className="d-block coin-image my-sm-5 my-0 mx-auto" />
        <h3 className="modal-status-title mb-0">{referAFriend?.referral_cta_page_header}</h3>
        <span className="modal-content-text mt-2">{referAFriend?.referral_cta_page_body}</span>
      </div>
      <div className="action-container split-equally">
        <PrimaryButton onClick={handleInviteClick}>Invite</PrimaryButton>
        <PrimaryButton className="secondary-colors" onClick={onModalClose}>
          Maybe Later
        </PrimaryButton>
      </div>
    </>
  ));
  setModalVariant(modalVariants.promptDialog);
}
